<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import moment from 'jalali-moment'
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      placeholderFlag: false,
    }
  },
  props: {
    title: {
      default: '',
      type: String,
    },
    classes: {
      type: String,
      default: '',
    },
    date: {
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    showPlaceholder: {
      default: false,
      type: Boolean,
    },
    hasDefaultDate: {
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    range: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    type: {
      type: String,
      default: 'date',
    },
    error: Boolean,
    errorText: String,
    required: Boolean,
  },
  mounted() {
    if (this.hasDefaultDate && !this.$route.params.id) {
      this.inputVal = this.formatedDate
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    formatedDate() {
      // const time = new Date().toLocaleString()
      // return moment(time, 'YYYY/MM/DD').utc()
      return new Date().toISOString()
    },
  },
  methods: {
    log() {
      this.placeholderFlag = true
    },
  },
}
</script>

<template>
  <div>
    <div class="d-flex align-items-center" :class="classes">
      <span class="labelStyle" :style="title.length > 12 ? { whiteSpace: 'none' } : { whiteSpace: 'nowrap' }">{{ title }}</span>
      <b-row class="w-100">
        <div class="position-relative d-flex">
          <span v-if="required" class="required"></span>
          <datePicker
            id="datePicker"
            class="w-100 mr-2"
            color="#556EE6"
            :class="disable ? 'disableDatePicker' : ''"
            @change="log"
            v-model="inputVal"
            :disabled="disable"
            :format="type === 'date' ? 'YYYY/MM/DD' : undefined"
            :display-format="type === 'date' ? 'jYYYY/jMM/jDD' : undefined"
            :clearable="clearable"
            locale="fa"
            :placeholder="placeholder"
            :range="range"
            :style="error && 'border: 1px solid #fe5e61; border-radius: 4px'"
            :type="type"
          ></datePicker>
          <div v-if="inputVal" class="close" @click="inputVal = ''">x</div>
          <!-- <div v-if="!placeholderFlag && !value && !showPlaceholder" class="custom-placeholder">
            {{ formatedDate }}
          </div> -->
        </div>
      </b-row>
      <br />
    </div>
    <div v-if="error" style="color: #fe5e61; width: 100% display: block; margin-right: 100px; font-size: 10px; margin-top: 10px;">{{ errorText }}</div>
  </div>
</template>

<style lang="scss" scoped>
.close {
  background: rgba(204, 204, 204, 0.414);
  border-radius: 100%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  color: #837c7c;
  display: grid;
  position: absolute;
  cursor: pointer;
  top: 8px;
  left: 60px;
  place-items: center;
}
.mainDatePicker {
  color: #556ee6;
}
::v-deep .vpd-input-group.vpd-disabled .vpd-icon-btn {
  background-color: #d8d8d8 !important;
}
.labelStyle {
  min-width: 91px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: right;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}

::v-deep .vpd-month-label {
  width: 105px !important;
}
::v-deep .vpd-input-group input {
  border: 1px solid #ced4da !important;
  border-radius: 0 4px 4px 0;
  width: 100%;
  padding-right: 8px;
}
::v-deep .vpd-input-group label {
  border-radius: 4px 0 0 4px;
  width: 40px;
}
::v-deep .vpd-input-group {
  display: flex;
  flex-direction: row-reverse;
}
::v-deep .vpd-icon-btn {
  margin: 0;
  display: flex;
  align-items: center;
}
.custom-placeholder {
  position: absolute;
  top: 7px;
  right: 19px;
  color: #dbdbdb;
  font-size: 13px;
  pointer-events: none;
}

::v-deep .form-control {
  padding: 3px;
  height: 2.2rem !important;
}
.required {
  border: 0.13rem solid #fe5e61;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  position: relative;
  right: 1px;
  background: #fe5e61;
  z-index: 1;
}
</style>
